import Resumen from '@/models/Resumen';
import Posicion from '@/models/Posicion';
import Producto from '@/models/Producto';
import axios from 'axios';
function defaultState() {
	return {
		tableData: [],
		titulosColumnas: [],
		tipoProductos: [],
		resumenes: [],
		tableOtros: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setTableData(state: { tableData: Posicion[] }, data: Posicion[]) {
		!Array.isArray(data) ? state.tableData.push(data) : (state.tableData = []);
	},
	setTitulosColumnas(state: { titulosColumnas: object[] }, data: object[]) {
		state.titulosColumnas = data;
	},
	setTipoProdutos(state: { tipoProductos: Producto[] }, data: Producto[]) {
		state.tipoProductos = data;
	},
	setResumenes(state: { resumenes: Resumen[] }, data: Resumen[]) {
		state.resumenes = data;
	},
	setTableOtros(state: { tableOtros: object[] }, data: object[]) {
		state.tableOtros = data;
	},
};
const actions = {
	async callResumenPosiciones({ commit, dispatch }, params: { data: object; start: number; limit: number }): Promise<Posicion[]> {
		const response = await axios.get(`./api/public/proxy/cgi/etenet_pEntregarStk?start=${params.start}&limit=${params.limit}`, params.data);
		if (response.data.items) {
			response.data.items.sort((a, b) => parseInt(b.id) - parseInt(a.id));
			response.data.items.forEach((element: Posicion) => {
				commit('setTableData', element);
			});
		}
		commit('setTitulosColumnas', response.data.titulosColumnas);
		commit('setTipoProdutos', response.data.productos as Producto);
		commit('setResumenes', response.data.resumenes as Resumen[]);
		commit('setTableOtros', response.data.renglonesComprobantes);
		return response.data.items;
	},
	resetItemsPosicion({ commit }): void {
		let empty: Object[] = [];
		commit('setTableData', empty);
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
